/**
 * WordPress dependencies
 */
// import { __ } from '@wordpress/i18n';
// import { Fragment } from '@wordpress/element';
// import { ToggleControl, BaseControl, Disabled } from '@wordpress/components';
// import { addFilter } from '@wordpress/hooks';

/**
 * Inner dependencies.
 */
// const { ProNotice, PaddingControl, MarginControl } = window.gutenify.components;

// const proAdvanceGenralMarginPadding = ( content, props ) => {
// 	return [ ...content, <Fragment key="gutenify-block-testimonial-inspector-advance-controls-margin-padding">
// 		<ProNotice>
// 			<Disabled>
// 				<PaddingControl
// 					{ ...props }
// 					// parentKey="blockAdvanceOptions"
// 					label={ __( 'Padding' ) }
// 					property="padding"
// 					disabled={ true }
// 				/>
// 				<hr />
// 				<MarginControl
// 					{ ...props }
// 					// parentKey="blockAdvanceOptions"
// 					label={ __( 'Margin' ) }
// 					disabled={ true }
// 				/>
// 			</Disabled>
// 		</ProNotice>
// 	</Fragment> ];
// };
// const proAdvanceGenralResponsiveVisibility = ( content ) => {
// 	return [ ...content, <Fragment key="gutenify-block-testimonial-inspector-advance-controls-margin-padding">
// 		<ProNotice>
// 			<Disabled>
// 				<BaseControl
// 					label={ __( 'Responsive Visibility' ) }
// 					initialOpen={ true }
// 					id="responsive-visibility"
// 				>
// 					<ToggleControl
// 						label={ __( 'Hide on Desktop', 'gutenify' ) }
// 						checked={ false }
// 						onChange={ ( ) => {} }
// 					/>
// 					<ToggleControl
// 						label={ __( 'Hide on Tablet', 'gutenify' ) }
// 						checked={ false }
// 						onChange={ ( ) => {} }
// 					/>
// 					<ToggleControl
// 						label={ __( 'Hide on Mobile', 'gutenify' ) }
// 						checked={ false }
// 						onChange={ ( ) => {} }
// 					/>
// 				</BaseControl>
// 			</Disabled>
// 		</ProNotice>
// 	</Fragment> ];
// };

// addFilter( 'gutenify-block-testimonial-inspector-advance-controls', 'gutenify/blocks/testimonial/inspector-advance-controls/margin-padding', proAdvanceGenralMarginPadding );
// addFilter( 'gutenify-block-post-carousel-inspector-advance-controls', 'gutenify/blocks/post-carousel/inspector-advance-controls/margin-padding', proAdvanceGenralMarginPadding );
// addFilter( 'gutenify-block-container-inspector-advance-controls', 'gutenify/blocks/container/inspector-advance-controls/responsive-visibility', proAdvanceGenralResponsiveVisibility );
